import React from 'react';
export const TD = ({ children, className, header, ...rest }) => {
    const style = { '--columnHeader': `"${header}: "` };
    return (React.createElement("td", { className: className, style: style, ...rest }, children));
};
